import styled, { css } from 'styled-components';
import { media } from '@prisjakt/ui-base';
import { productsWrapperMargin, itemFlex } from '../../constants';

export const COLUMN_WIDTH_LARGE = 245;
export const COLUMN_WIDTH_SMALL = 200;

const compareMarginBottom = '40px';

type ProductsWrapperProps = {
  isScrollable?: boolean;
  hasScrollSnap?: boolean;
};

export const CompareProducts = styled.div`
  display: flex;
  position: relative;
  min-width: 0;
  flex: ${itemFlex};
`;

export const ProductsWrapper = styled.div<ProductsWrapperProps>`
  display: flex;
  flex: ${itemFlex};
  margin: 0 ${productsWrapperMargin};
  margin-bottom: ${compareMarginBottom};

  ${media.mediumDown`
    margin: 0;
  `}

  ${props =>
    props.isScrollable &&
    css`
      overflow-x: auto;
      overflow-y: auto;
    `}

  ${props =>
    props.hasScrollSnap &&
    css`
      scroll-snap-type: x mandatory;
    `}
`;

export const Overlay = styled.div`
  background: rgba(0, 0, 0, 0.5);
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 1;
`;
